<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-04-02 09:44:45
 -->
<template>
  <div id="loyout">
    <el-container>
      <layoutAside></layoutAside>
      <el-container>
        <layoutHeader></layoutHeader>
        <el-main id="elmain">
          <div class="stickContent">
<!--            <transition name="main" mode="out-in">-->
            <keep-alive :include="catchName">
              <router-view v-if="keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!keepAlive"></router-view>
<!--            </transition>-->
          </div>
        </el-main>
        <el-footer height="00">
          <Bottom></Bottom>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import layoutAside from './aside/aside'
  import layoutHeader from './header/header'
  import Bottom from './Footer/bottom'
  import langSelect from '../../components/lang/langSelect'
  import { mapGetters } from 'vuex'
  import router from "../../router";
  export default {
    name: 'dc-home',
    components: {
      layoutHeader,
      Bottom,
      langSelect,
      layoutAside
    },
    data(){
      return{
        keepAlive:false,
        includeName:''
      }
    },
    created () {
    },
    computed:{
      env(){
        return process.env.NODE_ENV
      },
     ...mapGetters({catchName:'view/getCatchName'})
    },
    watch:{
      '$route':{
        handler(val, oldVal) {
          // console.log(val.name,'路由.name==');
          let index=this.catchName.indexOf(val.name);
          if(index<0){
            this.$store.dispatch('view/addCatchName',val.name);
            this.keepAlive=true;
          }else{
            if(val.query.keepAlive){
              let index=this.catchName.indexOf(val.name);
              if(index<0) {
                this.$store.dispatch('view/addCatchName', val.name);
              }
              this.keepAlive=true
            }else{
              this.keepAlive=false;
            }
          }
        }
      }
    },
    mounted() {
    }
  }
</script>

<style>
  .main-enter, .main-leave-to { opacity: 0; transform: translateY(30px); }
  .main-enter-active { transition: all 0.2s;  }
  .main-leave-active { position: absolute; transition: all 0.3s; }
</style>
<style lang="scss">
  * { margin: 0px; padding: 0px; }
  body {  background-color: #f2f2f2; font-size: 14px; color: #7d7c7c; }
  li { list-style: none; }
  a { text-decoration: none; }
  $top: top;
  $bottom: bottom;
  $left: left;
  $right: right;
  $leftright: ($left, $right);
  %w100 {  width: 100%; }
  %h100 { height: 100%;  }
  %cursor { cursor: pointer;  }
  html, body, #loyout, .el-container { width: 100%;  @extend %h100; }
  @mixin set-value($side, $value) {
    @each $prop in $leftright {
      #{$side}-#{$prop}: $value;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/layout.vue